import inviewAnim from "./modules/inview";
import { smoothScroll } from "./modules/libs";

window.addEventListener('load', () => {
  inviewAnim();
  smoothScroll();
  // setModal();
  // globalNav();
})